module.exports = __webpack_public_path__ + "static/media/logo-blue.200d9205.svg";